import { Outlet } from 'react-router-dom';
import { TopNav } from 'components/navigation/TopNav';
import { PageTransition } from 'components/ui/PageTransition';

export function LessonLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <TopNav />
      <main className="flex-1">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>
    </div>
  );
}
